<script>
	import thumb_OVpTGuisUlU from '$lib/Components/Youtube/images/OVpTGuisUlU.jpg?w=610';

	// images
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';

	import farmHouseWindow from './images/farmhouse-window-treatment-Indow-insert.jpg';
	import interiorStormWindowsOrInserts from './images/interior-storm-windows-or-inserts.jpg';
	import IwAccumatedSavingsDiagram from './images/IW-Accumulated-Savings-diagram.jpg';
	import IwSealWindowForWinter from './images/IW-Seal-Windows-For-The-Winter.jpg';
	import winterizeYourWindows from './images/winterize-your-windows-with-weatherstripping.jpg';
</script>

<Section backgroundColor="white">
	<p>
		They could be beautiful, historic or even high-quality, but if your windows
		are letting in air, you've got a problem. If you're facing this issue at
		your home or business, you may be wondering how to stop drafty windows. Do
		you have to replace them outright? Are there other effective ways to stop
		drafty windows? Fortunately, there's good news. Rather than paying for all
		new windows to be installed at your location, you have several alternatives
		for drafty window repair.
	</p>
	<h2>Why Windows Get Drafty</h2>
	<Image
		src={farmHouseWindow}
		alt="Looking for ways to fix drafty windows and extend their usefulness"
	/>
	<p>
		Old windows weather over time and even good windows will need some
		maintenance over the long haul. Glazing putty can fall away, cracks can
		develop, caulking can degrade, and some types of windows can shrink with
		age. If your windows are letting in cold air or not working as well as they
		could, your energy bill is probably suffering for it. That's why it's
		worthwhile to look for ways to fix drafty windows and extend their
		usefulness.
	</p>
	<p>
		In fact, there are several ways to breathe new life into your existing
		windows without shelling out big money for replacements. If you're looking
		for the best solutions to fix drafty windows and improve efficiency, here
		are six simple methods to consider:
	</p>
	<Bubble backgroundColor="transparent">
		<ul>
			<li><a href="#repair">Repair, replace or add new weatherstripping</a></li>
			<li><a href="#stopper">Get a window draft stopper</a></li>
			<li><a href="#polish">Cover cracks with nail polish</a></li>
			<li><a href="#film">Wrap the windows with film</a></li>
			<li><a href="#reglaze">Reglaze the window panes</a></li>
			<li><a href="#inserts">Use interior storm windows or inserts</a></li>
		</ul>
	</Bubble>
	<p>
		By prioritizing these energy saving methods, you could save an average of
		20% on your energy bills, which will really add up over time!
	</p>
	<Image src={IwAccumatedSavingsDiagram} alt="" />
</Section>

<Section backgroundColor="white" id="repair">
	<h2>Repair, replace or add new weatherstripping</h2>
	<p>
		Another way to prevent a draft from windows is with plastic
		weatherstripping. Install it along the side sashes and instantly improve the
		window's insulation from outside temperatures.
	</p>
	<Image src={winterizeYourWindows} alt="" />
</Section>

<Section backgroundColor="white" id="stopper">
	<h2>Get a window draft stopper</h2>
	<p>
		A draft stopper or draft snake is one of the most simple ways to block cold
		air from coming in through your window. Draft snakes are tubes or sleeves
		filled with dense materials that you place on the bottom edge of your
		window. They are not permanent and can be removed (or sometimes knocked
		down) very easily.
	</p>
</Section>

<Section backgroundColor="white" id="polish">
	<h2>Cover cracks with nail polish</h2>
	<p>
		Very small cracks in your window can be painted with clear nail polish.
		Don't try this with any windows that have coating as this can harm window
		coating.
	</p>
</Section>

<Section backgroundColor="white" id="film">
	<h2>Wrap the windows with film</h2>
	<p>
		During seasons when you know you won't be opening your windows, you may want
		to apply insulating film. Held by double-sided tape and easy to mount,
		shrink film can create an airtight seal over your existing windows. This
		non-permanent fix is a great way to stop window drafts, but the adhesive
		often damages surfaces during removal in the spring.
	</p>
	<Image
		src={IwSealWindowForWinter}
		alt="How To Easily Seal Windows For The Winter Months illustrated guide"
	/>
</Section>

<Section backgroundColor="white">
	<h2 id="reglaze">Reglaze the window panes</h2>
	<p>
		The glazing putty that seals window panes into the frame is prone to
		degradation over time. Removing all the existing putty and replacing it with
		fresh material can improve your windows' insulation for a few dollars and a
		little bit of time and effort.
	</p>
</Section>

<Section backgroundColor="white">
	<h2 id="inserts">Use interior storm windows or inserts</h2>
	<p>
		The beauty of interior storm windows is that they fit directly into your
		existing window frames, require minimal effort to install and significantly
		improve insulation. While interior storm windows give a tight seal against
		window drafts, they don't change the look of your windows. You preserve
		their original beauty or historic charm with zero risk of damage to the
		frame. And they cost less than a full window replacement. They also can
		improve energy efficiency.
	</p>
	<Image
		src={interiorStormWindowsOrInserts}
		alt="Farmhouse kitchen installation"
	/>
</Section>

<Section backgroundColor="white">
	<h2>Benefits of Indow Insulated Windows</h2>
	<p>
		Indow inserts are a more permanent solution to insulating drafty windows
		without being as high-cost as replacement windows. They are a relatively
		easy fix — after measuring your windows, you simply press the custom-fit
		inserts into place inside your window frames. They provide a major
		improvement in efficiency, increase insulation and reduce drafts, and can
		also add a layer of soundproofing.
	</p>
	<p>
		They are designed to be easy and quick to install and remove. They
		practically disappear once in your window. Wherever you live and whatever
		the size of your windows, Indow storm window inserts are a mix of all the
		other solutions to fixing drafty windows combined — except for repairing
		your windows. Indow inserts and drafty window repair go hand in hand.
	</p>
	<p>
		To learn more about making your windows draft free with Indow window
		inserts, check out our <a href="/solutions/insulating-drafty-windows"
			>drafts solutions page</a
		>
		or <a href="/how-to/get-indow-inserts">fill out our form</a> to speak with a representative.
	</p>
	<Youtube
		posterImageSrc={thumb_OVpTGuisUlU}
		src="https://www.youtube.com/embed/OVpTGuisUlU"
		title="How to Insulate Windows | Indow"
	/>
</Section>
